import React from 'react';
import PropTypes from 'prop-types';
import classNames from '../../../utils/classNames';
import './index.scss';

const VARIANT_TO_CLASS = {
    publish: 'status-chip--publish',
    going: 'status-chip--going',
    interested: 'status-chip--interested',
    pending: 'status-chip--pending',
    cancel: 'status-chip--cancel',
    complete: 'status-chip--complete',
    decline: 'status-chip--decline',
};

export const STATUS_CHIP_VARIANTS = Object.keys(VARIANT_TO_CLASS);

export default function StatusChip({
    variant = 'publish',
    children,
    showBullet = true,
    className = '',
    ...rest
}) {
    const variantClass = VARIANT_TO_CLASS[variant] || VARIANT_TO_CLASS.publish;

    return (
        <span
            className={classNames('status-chip', variantClass, className)}
            {...rest}
        >
            {showBullet ? <span className="status-chip__bullet" aria-hidden="true" /> : null}
            <span className="status-chip__label">{children}</span>
        </span>
    );
}

StatusChip.propTypes = {
    variant: PropTypes.oneOf(STATUS_CHIP_VARIANTS),
    children: PropTypes.node.isRequired,
    showBullet: PropTypes.bool,
    className: PropTypes.string,
};
